module.exports = __webpack_public_path__ + "static/media/rei_default03452e759c5b69e79d1c533ed11ac7ec.webp";